import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import SessionDataFactory  from "../../../factories/SessionDataFactory";
import SessionData from "../../../entities/sessionData/SessionData";
import { setSessionData } from "./actions";
import { IProductObject } from "../wishList/types";
import { setProductIdsForWishListAction } from "../wishList/actions";
import _ from "lodash";
import Config from "../../../config/config";

declare global {
  interface Window {
    AgentScreenWidget:any;
  }
}

export const sessionMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  if (action.type.includes(ActionTypes.SESSION_DATA.GET)) {
    const session: SessionData = action.payload.session;
    const sessionDataObject = SessionDataFactory.create(session);

    if (_.has(session, 'user.isAgent') && session.user.isAgent) {
      const aswScript = document.getElementById('agentScreenWidget');
      if (!aswScript) {
        const script = document.createElement('script');
        script.src = 'https://ypanel.yettel.rs/assets/js/agent-screen-widget.js';
        script.id = 'agentScreenWidget';
        document.body.appendChild(script);
        script.onload = () => {
          window.AgentScreenWidget.init({ tpanel: Config.api.tPanelUrl });
        };
      }
    }

    next(setSessionData(sessionDataObject, action.payload?.source));
    // set productIds for wish list because they are in session object
    sessionDataObject.user?.wishlist ?
      next(setProductIdsForWishListAction(sessionDataObject.user.wishlist.map((product: IProductObject) => product.productId))) :
      next(setProductIdsForWishListAction([]));
  }
};

export const sessionDataMiddleware = [sessionMiddleware];
